import {
  BaseActionObject,
  StateNodeConfig,
  assign,
  DoneInvokeEvent
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const toggleMarkCompleteTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "toggleDraftMarkComplete",
    onDone: {
      target: "idle",
      actions: assign((ctx, evt) => ({
        studyPlan: evt.data?.plan || ctx.studyPlan
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleDraftMarkComplete", {
            messageData: ["toggle mark complete"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
